import React, { useContext, useEffect, useState } from 'react';
import { IonContent, IonGrid, IonRow, IonCol, IonCard, IonCardContent, IonLoading, IonToast, IonItem, IonLabel, IonButton } from '@ionic/react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router';

// Components
import { HeaderComponent } from '../../../components';

// Helpers
import { extractConfigPage, loadPageInit, resolveColorMessageByStatusCode } from '../../../helpers';

// Contexts
import { AppContext } from '../../../contexts';

// Constants
import { APP_CONFIG } from '../../../constants';

// Validators
import { RoutesValidator } from '../../../validators';

// Actions
import { startCreateTransactionAction, resetErrorAction, setEntityAction } from '../../../redux';

// Sass
import './BenefitPage.scss';

export const BenefitPage = () => {

    const dispatch = useDispatch();
    const { entity: transaction } = useSelector(state => state.transaction);
    const { list: benefits } = useSelector(state => state.benefit);
    const { error } = useSelector(state => state.app);
    const [loading, setLoading] = useState(false);
    const [showToast, setShowToast] = useState({ show: false, error: null, status: null });

    const history = useHistory();
    const location = useLocation();
    const { isWeb } = useContext(AppContext);
    const pageConfig = extractConfigPage(location);
    const prevPage = loadPageInit();

    /**
     * Resetea la lista de beneficios disponibles para que se habilite la nueva consulta desde la página inicial
     */
    useEffect(() => {

        RoutesValidator.validatePageBenefit(benefits, history);

    }, [benefits]);

    /**
     * En caso de error
     */
    useEffect(() => {
    
        if (error) {

            setShowToast({ show: true, error: error.message, status: error.status });
        }

    }, [error]);

    /**
     * Maneja la selección del beneficio, creando la transacción
     * @param {Object} benefit Beneficio seleccionado
     */
    const handleSelected = ( benefit ) => {
        
        const entity = {
            ...transaction,
            benefitId: benefit.benefitId,
        };
        
        dispatch(setEntityAction(entity));
        dispatch(startCreateTransactionAction(entity, pageConfig, setLoading, history));

    };

    return (
        <>
            <IonLoading
                isOpen={loading}
                message={APP_CONFIG.CONTROLS.LOADING.MESSAGE}
            />
            <IonToast
                isOpen={showToast.show}
                onDidDismiss={() => {setShowToast(false); dispatch(resetErrorAction());}}
                message={showToast.error}
                duration={APP_CONFIG.CONTROLS.TOAST.DURATION}
                position={APP_CONFIG.CONTROLS.TOAST.POSITION}
                color={ resolveColorMessageByStatusCode(showToast.status) }
            />
            <HeaderComponent
                title={pageConfig.title}
                urlRedirect={prevPage}
            />
            <IonContent className="com-card-benefit animate__animated animate__fadeIn slow">

                {!isWeb &&

                    <>
                        {
                            benefits.map(benefit => {

                                return <div key={benefit.benefitId} className="com-card-benefit__item">
                                            <p>
                                                {`${benefit?.type} ${benefit?.title}`}
                                            </p>
                                            <IonButton
                                                type="button"
                                                shape="round"
                                                size="undefined"
                                                onClick={ () => handleSelected(benefit) }
                                            >
                                                SELECCIONAR
                                            </IonButton>
                                        </div>
                            })
                        }
                    </>
                }

                {
                    isWeb &&
                    <IonGrid>
                        <IonRow className='ion-text-left'>
                            <IonCol>
                                <h1>{pageConfig.title}</h1>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonCard>
                                    <IonCardContent className="ion-text-center">

                                        <>
                                            {
                                                benefits.map(benefit => {

                                                    return <IonItem>
                                                        <IonLabel>
                                                            <p>
                                                                {`${benefit?.type} ${benefit?.title}`}
                                                            </p>
                                                        </IonLabel>
                                                        <IonButton
                                                            type="button"
                                                            shape="round"
                                                            size="undefined"
                                                            onClick={ () => handleSelected(benefit) }
                                                        >
                                                            SELECCIONAR
                                                        </IonButton>
                                                    </IonItem>
                                                })
                                            }
                                        </>

                                    </IonCardContent>
                                </IonCard>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                }

            </IonContent>
        </>
    )
}
